/**
 * Logger que solo escribe en consola cuando REACT_APP_DEBUG está activado.
 * En producción no definas la variable (o REACT_APP_DEBUG=false) para no exponer logs.
 *
 * Uso: import { log, warn, error } from '../utils/logger';
 * .env o .env.local: REACT_APP_DEBUG=true  (solo cuando necesites depurar)
 */

const DEBUG = process.env.REACT_APP_DEBUG === 'true' || process.env.REACT_APP_DEBUG === '1';

export function log(...args) {
  if (DEBUG && typeof console !== 'undefined' && console.log) {
    console.log.apply(console, args);
  }
}

export function warn(...args) {
  if (DEBUG && typeof console !== 'undefined' && console.warn) {
    console.warn.apply(console, args);
  }
}

export function error(...args) {
  if (DEBUG && typeof console !== 'undefined' && console.error) {
    console.error.apply(console, args);
  }
}

export function isDebugEnabled() {
  return DEBUG;
}
